import { Grid, styled } from "@mui/material";
import { SxProps } from "@mui/system";


export const GridConteiner = styled(Grid, { label: "grid-conteiner" })(({ theme }) => ({
    flexGrow: 1,
    padding: '5px 10px',
    overflow: 'auto',
    height: '100%',
    // alignItems: 'flex-start'
    paddingBottom: '40px',
    overflowX: "hidden"

})
);